import { GridColDef } from "@mui/x-data-grid";
import DetailButton from "./DetailButton";

export const chatColumns: GridColDef[] = [
  {
    field: "",
    renderCell: DetailButton,
    width: 170,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "id",
    minWidth: 150,
    headerName: "Id",
    sortable: false,
    filterable: false,
  },
  {
    field: "hospital.hospitalName",
    headerName: "Hastane",
    flex: 1,
    minWidth: 400,
    valueGetter: (value, row) => row.hospital?.hospitalName || "",
  },
  {
    field: "message",
    headerName: "İleti",
    flex: 1,
    minWidth: 400,
  },
  {
    field: "fullName",
    headerName: "Ad Soyad",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "refChat.message",
    headerName: "Ref İleti",
    flex: 1,
    minWidth: 150,
    valueGetter: (value, row) => row.refChat?.message || "",
  },

  {
    field: "creationTime",
    headerName: "Tarih",
    type: "dateTime",
    flex: 1,
    minWidth: 180,
    valueGetter: (v, r) => new Date(v),
  },
];
